module.exports = __webpack_public_path__ + "media/images/new/icons/step_arrow-720fa21bb9c646b2a314067f3c17c866.png";